<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      dark
        :footer-props="{
        prevIcon: '〈',
        nextIcon: '〉'
      }"
      :search="search"
      class="printHide"
    >
  <template v-slot:item="{ item }">
                    <tr v-bind:class="{'customRow': item.jurisdiction==='Custom'}">
                        <td>{{item.jurisdiction}}</td>
                        <td><div style="text-align: center">{{ Number(item.population).toLocaleString()  }}</div></td>
                        <td><div style="text-align: center">{{ Number(item.clinics).toLocaleString()  }}</div></td>
                        <td><div style="text-align: center">{{ Number(item.workers).toLocaleString()  }}</div></td>
                    </tr>
                </template>
    </v-data-table>
    <v-data-table
      :headers="headers"
      :items="items"
      dark
        :footer-props="{
        prevIcon: '〈',
        nextIcon: '〉'
      }"
      :search="search"
      class="printShow"
      :items-per-page="500"
    >
  <template v-slot:item="{ item }">
                    <tr v-bind:class="{'customRow': item.jurisdiction==='Custom'}">
                        <td>{{item.jurisdiction}}</td>
                        <td><div style="text-align: center">{{ Number(item.population).toLocaleString()  }}</div></td>
                        <td><div style="text-align: center">{{ Number(item.clinics).toLocaleString()  }}</div></td>
                        <td><div style="text-align: center">{{ Number(item.workers).toLocaleString()  }}</div></td>
                    </tr>
                </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

  export default {
    computed: {
        ...mapState(['personnelDisplay', 'selectedState'])
    },
    props: {
      items: Array
    },
    data() {
      return {
        search: '',
        fields: ['state', 'population', 'clinics', 'workers'],
        headers: [
          {text: "Site",
          align: "start",
          sortable: true,
          value: "jurisdiction",
          
          },
          {text: "Population", value: "population", align: "center"},
          {text: "Clinics", value: "clinics", align: "center"},
          {text: "Total Workers", value: "workers", align: "center"},
        ],
      }
    }
  }
</script>